//Clientes

// src/api/client.mjs
import { getClientId } from '../utils/clientStorage.mjs';

const baseUrl = process.env.REACT_APP_BASE_URL || 'https://api.eigor.com.br/core';

export const apiUrl = (path) => {
    const clienteId = getClientId() || 1; // fallback para 1 se não houver cliente
    return `${baseUrl}/${path}/${clienteId}`;
};

export const apiUrl2 = (path) => {
    const clienteId = getClientId() || 1;
    // Se path está vazio, é para POST (criar) - não adiciona /plataformas/
    // Se path tem valor, é para GET (buscar) - adiciona /plataformas/
    return path ? `${baseUrl}/plataformas/${clienteId}/plataformas/${path}` : `${baseUrl}/plataformas/${clienteId}`;
};

export const apiUrl2Put = (id) => {
    const clienteId = getClientId() || 1;
    return `${baseUrl}/plataformas/${clienteId}/${id}`;
};

export const apiUrl3 = (path) => {
    const clienteId = getClientId() || 1;
    return `${baseUrl}/promocional/${clienteId}/promocional/${path}`;
};

export const apiUrlDadosGrupo = (id) => {
    const clienteId = getClientId() || 1;
    return `${baseUrl}/dados-do-grupo/${clienteId}/${id}`;
};
